import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { type FC, type ReactNode } from 'react';
import { isRetriableNetworkError } from './queryErrorGuards';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60 * 1000,
            retry: (failureCount, error) => {
                if (failureCount >= 1) return false;
                return isRetriableNetworkError(error);
            },
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
        },
    },
});

export const TanStackQueryProvider: FC<{ children: ReactNode }> = ({ children }) => (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

export { queryClient };
